<template>
  <div class="empty-state">
    <div class="empty-state__icon">
      <fa-icon :icon="icon" />
    </div>
    <h3 class="empty-state__title">{{ title }}</h3>
    <p v-if="description" class="empty-state__description">{{ description }}</p>
    <slot name="action"></slot>
  </div>
</template>

<script>
export default {
  name: "EmptyState",
  props: {
    icon: {
      type: [String, Array],
      default: "inbox",
    },
    title: {
      type: String,
      default: "Sem registros disponíveis",
    },
    description: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  margin: 20px 0;
  background: #f8f9fa;
  border: 2px dashed #cbd5e0;
  border-radius: 12px;
  text-align: center;
  transition: all 0.3s ease;
}

.empty-state:hover {
  background: #f1f3f5;
  border-color: #a0aec0;
}

.empty-state__icon {
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e2e8f0;
  border-radius: 50%;
  margin-bottom: 24px;
  color: #718096;
  font-size: 36px;
  transition: all 0.3s ease;
}

.empty-state:hover .empty-state__icon {
  background: #cbd5e0;
  transform: scale(1.05);
}

.empty-state__title {
  font-size: 18px;
  font-weight: 600;
  color: #2d3748;
  margin: 0 0 8px 0;
  line-height: 1.4;
}

.empty-state__description {
  font-size: 14px;
  color: #718096;
  margin: 0 0 20px 0;
  max-width: 400px;
  line-height: 1.5;
}
</style>
